<template>
  <!-- <v-card
    class="mx-auto start-card"
    max-width="400"
    color="#EEEEFF"
  >  -->
  <div class="my-4">
  <v-card
    class="mx-auto mode-button"
    width="400"
    color="rgba(0,0,0,0)"
    elevation=0
    @mouseover="mouseover"
    @mouseleave="mouseleave"
  >
    <p v-if="selected!='start'&&changeHover" style="font-size:20px;background-color:rgba(0,0,0,0.1);color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>ゲームを始める</b></p>
    <p v-else-if="selected!='start'" style="font-size:20px;color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>ゲームを始める</b></p>
    <p v-else style="background-color:rgba(0,0,0,0.2);font-size:20px;color:#FFFFFF;"><b>ゲームを始める{{message}}</b></p>

  </v-card>
    <v-expand-transition>
      <v-card
        v-if="selected=='start'"
        class="mx-auto mt-n4"
        elevation=0
        max-width="400"
        color="rgba(0,0,0,0.2)"
      >

        <div class="input-form my-auto">
          <div class="botton-field mt-4">
            <v-row class="mx-auto mt-n4 mb-4" style="width:320px">
              <v-col v-if="!roomIdFixed" class="mx-auto" style="width:160px">
                <v-btn v-if="buttonMode=='join'" class="join-button white--text" v-on:click="joinMode" elevation=3 tile large color="rgba(20,60,150,0.8)" max-width=140>部屋に<span style="font-size:20px"><b>入る</b></span></v-btn>
                <v-btn v-else class="join-button white--text" v-on:click="joinMode" elevation=1 outlined text tile large style="background-color:rgba(20,60,150,0)" max-width=140>部屋に<span style="font-size:20px"><b>入る</b></span></v-btn>
              </v-col>
              <v-col v-else class="mx-auto" style="width:160px">
                <v-btn v-if="buttonMode=='join'" class="join-button white--text" elevation=3 tile large color="rgba(20,60,150,0.8)" max-width=140>部屋に<span style="font-size:20px"><b>入る</b></span></v-btn>
              </v-col>

              <v-col v-if="!roomIdFixed" class="mx-auto" style="width:160px">
                <v-btn v-if="buttonMode=='create'" class="create-button white--text" v-on:click="createMode" elevation=3 large tile color="rgba(150,20,60,0.8)" max-width=140>部屋を<span style="font-size:20px"><b>作る</b></span></v-btn>
                <v-btn v-else class="create-button white--text" v-on:click="createMode" elevation=1 outlined text tile large max-width=140 style="background-color:rgba(150,20,60,0)">部屋を<span style="font-size:20px"><b>作る</b></span></v-btn>
              </v-col>
              <v-col v-else class="mx-auto" style="width:160px">
                <v-btn class="create-button white--text" elevation=1 outlined text tile large style="background-color:rgba(150,20,60,0)" max-width=140>部屋を<span style="font-size:20px"><b>作る</b></span></v-btn>
              </v-col>
            </v-row>
          </div>

          <v-expand-transition>
            <v-card
              v-show="buttonMode"
              elevation=0
              color="rgba(0,0,0,0)"
            >
              <div class="input-field">
                <v-text-field outlined filled class="centered-input shrink mx-4 name-input-box" v-model="userNameInput" label="ユーザ名" dark background-color="rgba(0,0,0,0)" max-width=200></v-text-field>
                <v-expand-transition>
                  <v-card
                    v-show="buttonMode=='join'"
                    elevation=0
                    color="rgba(0,0,0,0)"
                  >
                    <v-text-field v-if="roomIdFixed" outlined disabled filled class="centered-input shrink mx-4 room-input-box" v-model="roomIdInput" label="ルームID" dark background-color="rgba(0,0,0,0)" max-width=200></v-text-field>
                    <v-text-field v-else outlined filled class="centered-input shrink mx-4 room-input-box" v-model="roomIdInput" label="ルームID" dark background-color="rgba(0,0,0,0)" max-width=200></v-text-field>
                  </v-card>
                </v-expand-transition>
              </div>
            </v-card>
          </v-expand-transition>
          <div class="send-button">
            <v-btn v-if="(buttonMode=='create'&&userNameValidate)" class="send-button white--text" v-on:click="start" elevation=3 large tile color="rgba(150,20,60,0.8)" max-width=140><span style="font-size:20px"><b>始める</b></span></v-btn>
            <v-btn v-else-if="(buttonMode=='join'&&userNameValidate&&roomIdValidate)" class="send-button white--text" v-on:click="start" elevation=3 large tile color="rgba(20,60,150,0.8)" max-width=140><span style="font-size:20px"><b>始める</b></span></v-btn>
            <v-btn v-else class="send-button white--text" elevation=3 outlined text large tile color="rgba(150,20,60,0.8)" max-width=140><span style="font-size:20px"><b>始める</b></span></v-btn>
          </div>
        </div>
      </v-card>
    </v-expand-transition>
  </div>
  <!-- </v-card> -->
</template>
<script>
export default {
  props: ['selected', 'userName', 'roomId', 'roomIdFixed'],
  components: {
  },
  data () {
    return {
      buttonMode: 'join',
      message: "",
      changeHover: false,
      roomIdInput: '',
      userNameInput: '',
    }
  },
  methods: {
    createMode() {
      this.buttonMode = 'create'
    },
    joinMode() {
      this.buttonMode = 'join'
      this.roomIdInput = ''
    },
    pushed() {
      if (this.selected != 'start'){
        this.$emit("select-mode", {selected: "start"})
      }else {
        this.$emit("select-mode", {selected: ""})
      }
    },
    start: function() {
      // var url = ""
      // const splitedUrl = String(location.href).split('/')
      // console.log(splitedUrl)
      // for (var i=0; i<splitedUrl.length-1; i++) {
      //   url += splitedUrl[i]
      // }
      if (this.buttonMode == 'create'){
        window.open( 'room/?username=' + this.userNameInput + '&mode=create', "window_name", "width=1200,height=900,scrollbars=yes");
      }else {
        window.open( 'room/' + this.roomIdInput + '?username=' + this.userNameInput + '&roomid=' + this.roomIdInput + '&mode=join', "window_name", "width=1200,height=900,scrollbars=yes");
      }

      // create APIを叩く
      // var self = this
      // const socket = new WebSocket(this.webSocketUrl)
      // socket.onopen = function(event){
      //   console.log(event)
      //   console.log("Successfully connected to the echo WebSocket Server");
      //   if (self.buttonMode == 'create'){
      //     console.log({"action": "create", "data": {"userName": self.userNameInput}})
      //     socket.send(JSON.stringify({"action": "create", "data": {"userName": self.userNameInput}}))
      //   }else if(self.buttonMode == 'join'){
      //     console.log({"action": "join", "data": {"roomId": self.roomIdInput, "userName": self.userNameInput}})
      //     socket.send(JSON.stringify({"action": "join", "data": {"roomId": self.roomIdInput, "userName": self.userNameInput}}))
      //   }
      // }
      // socket.onmessage = function(event){
      //   console.log("Received!!!!")
      //   console.log(event)
      //   const res = JSON.parse(event.data)
      //
      //   var myInfo = {
      //     name: self.userNameInput,
      //     id: res.data.userId,
      //     isHost: false
      //   }
      //
      //   // ページ遷移
      //   if (self.buttonMode == 'create'){
      //     myInfo.isHost = true
      //     self.$store.commit('setMyInfo', myInfo)
      //     self.$store.commit('setUsers', [{userId: res.data.userId, userName: self.userNameInput}])
      //     self.$router.push({ name: 'Room', params: { roomId: String(res.data.roomId), userName: self.userNameInput, socket: socket, type: 'create' }})
      //
      //   }else {
      //     self.$store.commit('setMyInfo', myInfo)
      //     var loadedUsers = res.data.userList
      //     self.$store.commit('setUsers', loadedUsers)
      //     self.$router.push({ name: 'Room', params: { roomId: String(self.roomIdInput), userName: self.userNameInput, socket: socket, type: 'join' }})
      //   }
      // }
    },
    mouseover: function(){
      this.changeHover = true
    },
    mouseleave: function(){
      this.changeHover = false
    },
  },
  computed: {
    userNameValidate () {
      if (this.userNameInput != ""){
        return true
      }
      return false
    },
    roomIdValidate () {
      if (this.roomIdInput != ""){
        return true
      }
      return false
    },
  },
  created (){
    this.userNameInput = this.userName
    if (this.roomId) {
      this.roomIdInput = this.roomId
      this.buttonMode=='join'
    }
  }
}
</script>
<style>
</style>
